import {
  EBrokerSelfRequestFormWidgetActionTypes,
  TBrokerSelfRequestFormWidgetActions,
} from '../../actions/brokerSelfRequestFormWidget';
import { IBrokerSelfRequestFormWidget } from '../../types/brokerSelfRequestFormWidget';

const initialState: IBrokerSelfRequestFormWidget = {
  active: false,
  loading: false,
};

export function brokerSelfRequestFormWidgetReducer(
  state: IBrokerSelfRequestFormWidget = initialState,
  action: TBrokerSelfRequestFormWidgetActions,
): IBrokerSelfRequestFormWidget {
  switch (action.type) {
    case EBrokerSelfRequestFormWidgetActionTypes.SetActive:
      return {
        ...state,
        active: action.payload,
      };

    case EBrokerSelfRequestFormWidgetActionTypes.SetLoading:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
